import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchSessionsApi,
  createSessionApi,
  updateSessionApi,
  deleteSessionApi,
  restoreSessionApi,
  permanentDeleteSessionApi,
  fetchDeletedSessionsApi,
} from "./sessionApi";

export const getSessions = createAsyncThunk(
  "session/getSessions",
  async ({ page, limit, search, locationId }, { rejectWithValue }) => {
    try {
      const res = await fetchSessionsApi({ page, limit, search, locationId });
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getDeletedSessions = createAsyncThunk(
  "session/getDeletedSessions",
  async (_, { rejectWithValue }) => {
    try {
      const res = await fetchDeletedSessionsApi();
      return res.data.data.items;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const createSession = createAsyncThunk(
  "session/createSession",
  async (data, { rejectWithValue }) => {
    try {
      const res = await createSessionApi(data);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateSession = createAsyncThunk(
  "session/updateSession",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await updateSessionApi(id, data);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteSession = createAsyncThunk(
  "session/deleteSession",
  async (id, { rejectWithValue }) => {
    try {
      await deleteSessionApi(id);
      return id;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const restoreSession = createAsyncThunk(
  "session/restoreSession",
  async (id, { rejectWithValue }) => {
    try {
      await restoreSessionApi(id);
      return id;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const permanentDeleteSession = createAsyncThunk(
  "session/permanentDeleteSession",
  async (id, { rejectWithValue }) => {
    try {
      await permanentDeleteSessionApi(id);
      return id;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const sessionSlice = createSlice({
  name: "session",
  initialState: {
    sessions: [],
    deletedSessions: [],
    loading: false,
    total: 0,
    page: 1,
    totalPages: 1,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(getSessions.fulfilled, (state, action) => {
        state.sessions = action.payload.items;
        state.total = action.payload.total;
        state.page = action.payload.page;
        state.totalPages = action.payload.totalPages;
      })

      .addCase(createSession.fulfilled, (state, action) => {
        state.sessions.unshift(action.payload);
      })

      .addCase(updateSession.fulfilled, (state, action) => {
        const index = state.sessions.findIndex(
          (s) => s.id === action.payload.id
        );
        if (index !== -1) state.sessions[index] = action.payload;
      })

      .addCase(deleteSession.fulfilled, (state, action) => {
        state.sessions = state.sessions.filter(
          (s) => s.id !== action.payload
        );
      })

      .addCase(getDeletedSessions.fulfilled, (state, action) => {
        state.deletedSessions = action.payload;
      });
  },
});

export default sessionSlice.reducer;